/**
 * A simplified representation of a call.
 */
export class SimpleCall {

  readonly id: string;
  readonly dialGroupId?: string;
  readonly shuffleDialGroupId?: string;
  readonly connectingAt: Date;
  readonly disconnectedAt?: Date;

  constructor(deriveFrom?: Partial<SimpleCall>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }

    this.connectingAt = new Date(this.connectingAt);

    if (this.disconnectedAt) {
      this.disconnectedAt = new Date(this.disconnectedAt);
    }
  }
}